import {
  UPDATE_GIVEN_DATA_KEYS,
  UPDATE_GIVEN_DATA_KEYS_REVIEW,
} from './index.js';

export default partialData => (dispatch, getState) => {
  const { form: { selectedForm: { isActive } = {} } = {} } = getState();
  return dispatch({
    type: isActive ? UPDATE_GIVEN_DATA_KEYS : UPDATE_GIVEN_DATA_KEYS_REVIEW,
    payload: { partialData },
  });
};
